<template>
  <div>
    <div v-if="showModal" class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-auto my-6 mx-auto max-w-3xl">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-3xl font-semibold">
              {{ pageType }} User 
            </h3>
            <button class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" v-on:click="toggleModal()">
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!--body-->
          <div class="relative p-6 flex-auto">
            <div class="flex-auto px-0 lg:px-0 py-0 pt-0">
              <div class="w-full lg:w-12/12 px-0"  v-if="alertType != ''">
                <div 
                class="text-white px-4 py-2 border-0 rounded relative mb-4"
                v-bind:class="{'bg-emerald-500': alertType == 'Success', 'bg-red-500': alertType == 'Failed'}">
                  <span class="text-m inline-block mr-5 align-middle">
                    <i class="fas fa-bell"></i>
                  </span>
                  <span class="inline-block align-middle mr-8">
                    <b class="capitalize">{{ alertType }}!</b> {{ alertMessage }}
                  </span>
                  <button class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-2 mr-6 outline-none focus:outline-none">
                    <span>×</span>
                  </button>
                </div>
              </div>
              <div class="flex flex-wrap">
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                      class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Full Name 
                    </label>
                    <input
                      type="text"
                      v-model="client.fullname"
                      name="fullname"

                      class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      
                    />
                  </div>

                  <div class="relative w-full mb-3">
                    <label
                      class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      User Name 
                    </label>
                    <input
                      type="text"
                      v-model="client.username"
                      name="username"

                      class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      
                    />
                  </div>
                </div>
                <div class="w-full lg:w-6/12 px-4">
                  <div class="relative w-full mb-3">
                    <label
                      class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Password 
                    </label>
                    <input
                      type="password"
                      v-model="client.password"
                      name="password"

                      class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                      
                    />
                  </div>

                  <div class="relative w-full mb-3">
                    <label
                      class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Role 
                    </label>
                    <select v-model="client.role_id" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                      <option v-for="(item, key) in roles" :value="item.id" :key="key">
                        {{item.role}}
                      </option>
                    </select>                    
                  </div>

                </div>
              </div>
            </div>          
          </div>  
          <!--footer-->
          <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
            <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" v-on:click="toggleModal()">
              Close
            </button>
            <button class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" 
            v-on:click="onSubmit(this.client)">
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import RoleDataService from "@/services/RoleDataService";
  
  export default {
    data() {
      return {
        client: this.clientProps,
        roles: []
      };
    },
    props: {
      pageType: String,
      onSubmit: {type: Function},
      alertType: String,
      alertMessage: String,
      showModal: Boolean,
      toggleModal: {type: Function},
      clientProps: {type: Object}    
    },
    components: {
      
    },
    watch: { 
      clientProps: function(newVal, oldVal) { // watch it
        console.log('Prop changed role: ', newVal, ' | was: ', oldVal)
        this.client = newVal
      },
      showModal: function(newVal, oldVal) { // watch it
        console.log('Prop changed showModal: ', newVal, ' | was: ', oldVal)
        if(newVal){
          this.getRoles() 
        }
      }
    },
    methods: {
      getRoles(){
        RoleDataService.getAll(100, 1)
          .then(response => {
            this.roles = response.data["data"]["roles"];
            
          })
          .catch(e => {
            console.log(e);
          });
      }
    }
  }
</script>